import { withAbortableTimeout } from "@trafficplace/api-client";

export const INTERACTIVE_READ_TIMEOUT_MS = 10_000;

export function withInteractiveReadTimeout<T>(
  startRequest: (signal: AbortSignal) => Promise<T>,
): Promise<T> {
  return withAbortableTimeout(startRequest, INTERACTIVE_READ_TIMEOUT_MS);
}
